// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3EQSe","content":"styles_content__17GrZ","checkbox":"styles_checkbox__3NL-6","checkboxLabel":"styles_checkboxLabel__3Bq1k"};